module.exports = __webpack_public_path__ + "img/1.f26c79f2.jpg";